/**
 * Created by Henry Huang.
 */
import settings from './modules/settings';

export default {
  settings,
};



// WEBPACK FOOTER //
// ./src/default/reducers.js